import {BaseModel} from "../base";
import {AdminMessageModel} from "./message";

class AdminConversationModel extends BaseModel {
    $getMessages() {
        return new Promise((resolve, reject) => {

            this
                .$get('messages')
                .then((messages) => {
                    messages = messages.map((message) => {
                        return new AdminMessageModel(message);
                    });

                    resolve(messages);
                });

        });
    }

    $postMessage(body) {
        return new Promise((resolve, reject) => {

            this
                .$post('self', {}, body)
                .then((message) => {
                    message = new AdminMessageModel(message);

                    resolve(message);
                });

        });
    }
}

export {
    AdminConversationModel
}
